const $inject = ['$filter'];

const genericSortingFilter = ($filter) => {
  return (collection, expression) => {
    return $filter('orderBy')(collection, expression);
  };
};

genericSortingFilter.$inject = $inject;

export default genericSortingFilter;



// WEBPACK FOOTER //
// ./src/filters/genericSortingFilter.js